/**
 * @description 管理器脚本的基类，继承此此类的脚本也需要继承三个函数
 * @author TKB
 * @creat 2024-01-02 15:49:46
 */
export class BaseManager {
  constructor(manager) {
    this.manager = manager;
    this.init(manager);
  }

  /**
   * 传入管理器变量，方便访问其他管理模块
   * @param {*} manager
   */
  init(manager) {
    this.manager = manager;
  }

  update(dt) {}

  clear() {
    this.manager = null;
  }
}
